/* workspace-admin/CustomFieldsAdmin — CRM Configuration > Custom Fields.
   Renders the workspace-scoped Custom Fields UI (SettingsFields) inside the
   Workspace Admin console. wsId comes from the route param so SA/OA viewing
   a different workspace see the correct fields, not the session's activeWorkspaceId. */
import React from 'react';
import { useParams } from 'react-router-dom';
import { findWorkspace } from '../platform/platformStore';

const _EMPTY_SS = { state: { customFields: {} } };

export default function CustomFieldsAdmin({ data }) {
  const { wsId } = useParams();
  const ws = findWorkspace(data.state, wsId);
  if (!ws) return null;

  const FieldsPanel = window.SettingsFields;
  if (!FieldsPanel) {
    return (
      <div className="nx-cc-page">
        <div className="nx-empty" style={{ marginTop: 60 }}>
          <span>Custom Fields panel loading…</span>
        </div>
      </div>
    );
  }

  return (
    <div className="nx-cc-page">
      <FieldsPanel ss={_EMPTY_SS} wsId={wsId} />
    </div>
  );
}
